import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingKind, LoadingService } from '../services/loading';

/**
 * Controlli di sessione e tracciamento accessi: nessuna animazione.
 * Creazione, aggiornamento, upload e operazioni collegate: "Salvataggio".
 * Elenchi, dettagli, eliminazioni, email, login e download: "Caricamento".
 */
export function classifyLoadingRequest(url: string): 'skip' | LoadingKind {
    let path = url.split('?')[0];
    try {
        path = new URL(url, 'http://localhost').pathname;
    } catch {
        // url relativo già ripulito sopra
    }

    if (/\/auth\/(check|user)\/?$/.test(path) || /\/request-access\/create\/?$/.test(path)) {
        return 'skip';
    }
    if (/\/(create|update|upload|copy|sync-customer|create-folder)\/?$/.test(path)) {
        return 'save';
    }
    return 'load';
}

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    constructor(private loadingService: LoadingService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const kind = classifyLoadingRequest(request.url);
        if (kind === 'skip') {
            return next.handle(request);
        }
        this.loadingService.begin(kind);
        return next.handle(request).pipe(
            finalize(() => this.loadingService.end(kind))
        );
    }
}
